import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'

import { CaneDiagnosis } from './get-diagnosis-by-id'

interface ListWeedDiagnosesResponse {
  count: number
  page: number
  limit: number
  next: string
  previous: string
  results: Array<CaneDiagnosis>
}

type ListWeedDiagnosesParams = {
  idCompany: number
  pageLimit?: number
  lastItem?: string | null
  orderBy?: string | null
  search?: string | null
  searchType?: string | null
}

export async function listWeedDiagnoses(
  params: ListWeedDiagnosesParams,
  signal?: AbortSignal,
) {
  const { pageLimit: limit, ...rest } = params

  const { data } = await companiesApi.get<ListWeedDiagnosesResponse>(
    apiRoutes.listWeedDiagnoses('cane'),
    {
      params: {
        limit,
        ...rest,
      },
      signal,
    },
  )

  return data
}
